import { InvalidDeviceVaultEntryError } from './invalid-device-vault-entry-error';
export class InvalidDateDeviceVaultEntryError extends InvalidDeviceVaultEntryError {
    constructor(entry) {
        super(`Date '${entry.addedAt.toString()}' of entry '${entry.entryId}' is invalid.`, entry);
        this.entry = entry;
        this.name = 'InvalidDateDeviceVaultEntryError';
    }
}
